import { render, staticRenderFns } from "./AddSalesInvoiceComponent.vue?vue&type=template&id=6155a571"
import script from "./AddSalesInvoiceComponent.vue?vue&type=script&lang=js"
export * from "./AddSalesInvoiceComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports